"use strict";
// @df/api - Unified API client for DataFre8 applications
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserService = exports.ContactService = exports.NewsletterService = exports.PointCloudService = exports.InvitationService = exports.AuthService = exports.FileUploadHelper = exports.SearchHelper = exports.PresignedDownloadHelper = exports.PaginationHelper = exports.setJwtLoginField = exports.resolveJwtLoginField = exports.buildApiUrl = exports.resolveAuthBaseUrl = exports.resolveApiBaseUrl = exports.ApiClient = exports.apiClient = exports.authService = exports.authManager = void 0;
// Note: Types are available in .d.ts files for TypeScript consumers
// Runtime JavaScript consumers should use the services and helpers directly
// Export authentication manager
var auth_1 = require("./auth");
Object.defineProperty(exports, "authManager", { enumerable: true, get: function () { return auth_1.authManager; } });
// Export unified auth service
var authService_1 = require("./authService");
Object.defineProperty(exports, "authService", { enumerable: true, get: function () { return authService_1.authService; } });
// Export API client
var client_1 = require("./client");
Object.defineProperty(exports, "apiClient", { enumerable: true, get: function () { return client_1.apiClient; } });
Object.defineProperty(exports, "ApiClient", { enumerable: true, get: function () { return client_1.ApiClient; } });
// Export API base URL helpers
var apiBase_1 = require("./config/apiBase");
Object.defineProperty(exports, "resolveApiBaseUrl", { enumerable: true, get: function () { return apiBase_1.resolveApiBaseUrl; } });
Object.defineProperty(exports, "resolveAuthBaseUrl", { enumerable: true, get: function () { return apiBase_1.resolveAuthBaseUrl; } });
Object.defineProperty(exports, "buildApiUrl", { enumerable: true, get: function () { return apiBase_1.buildApiUrl; } });
Object.defineProperty(exports, "resolveJwtLoginField", { enumerable: true, get: function () { return apiBase_1.resolveJwtLoginField; } });
Object.defineProperty(exports, "setJwtLoginField", { enumerable: true, get: function () { return apiBase_1.setJwtLoginField; } });
// Export helpers
var helpers_1 = require("./helpers");
Object.defineProperty(exports, "PaginationHelper", { enumerable: true, get: function () { return helpers_1.PaginationHelper; } });
Object.defineProperty(exports, "PresignedDownloadHelper", { enumerable: true, get: function () { return helpers_1.PresignedDownloadHelper; } });
Object.defineProperty(exports, "SearchHelper", { enumerable: true, get: function () { return helpers_1.SearchHelper; } });
Object.defineProperty(exports, "FileUploadHelper", { enumerable: true, get: function () { return helpers_1.FileUploadHelper; } });
// Export services
var services_1 = require("./services");
Object.defineProperty(exports, "AuthService", { enumerable: true, get: function () { return services_1.AuthService; } });
Object.defineProperty(exports, "InvitationService", { enumerable: true, get: function () { return services_1.InvitationService; } });
Object.defineProperty(exports, "PointCloudService", { enumerable: true, get: function () { return services_1.PointCloudService; } });
Object.defineProperty(exports, "NewsletterService", { enumerable: true, get: function () { return services_1.NewsletterService; } });
Object.defineProperty(exports, "ContactService", { enumerable: true, get: function () { return services_1.ContactService; } });
Object.defineProperty(exports, "UserService", { enumerable: true, get: function () { return services_1.UserService; } });
// Import for default export
const auth_2 = require("./auth");
const client_2 = require("./client");
const helpers_2 = require("./helpers");
const services_2 = require("./services");
// Default export - main API instance
const dfApi = {
    auth: auth_2.authManager,
    client: client_2.apiClient,
    services: {
        AuthService: services_2.AuthService,
        InvitationService: services_2.InvitationService,
        PointCloudService: services_2.PointCloudService,
        NewsletterService: services_2.NewsletterService,
        ContactService: services_2.ContactService,
        UserService: services_2.UserService
    },
    helpers: {
        PaginationHelper: helpers_2.PaginationHelper,
        PresignedDownloadHelper: helpers_2.PresignedDownloadHelper,
        SearchHelper: helpers_2.SearchHelper,
        FileUploadHelper: helpers_2.FileUploadHelper
    }
};
exports.default = dfApi;
